import { access_token } from "./backendclient";
import { jsError, NOTIFICATIONS_ENABLED } from "../../common/utils";
import { store } from "../../main";

const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL ?? "ws://localhost:5003/ws";

let ws;

const messageQueue = [];

export function openWebSocket() {
  if (!NOTIFICATIONS_ENABLED) return;

  if (ws !== undefined && ws.readyState === WebSocket.CONNECTING) {
    return; // do not connect twice in React development environment (Strict mode)
  }

  ws = new WebSocket(WEBSOCKET_URL, access_token);
  //ws = new WebSocket(`${WEBSOCKET_URL}?token=${token}`);

  ws.onopen = (e) => {
    if (messageQueue.length > 0) {
      for (const message of messageQueue) {
        ws.send(message);
      }
      messageQueue.length = 0;
    }
  };

  ws.onmessage = (e) => {
    try {
      const message = JSON.parse(e.data);
      message.timestamp = Date.now();

      store.dispatch({
        type: "NOTIFICATION_ADD",
        payload: message,
      });
      //notify(message.sender, message.payload);
    } catch (err) {
      jsError(err);
    }
  };

  ws.onerror = (e) => jsError(e);

  ws.onclose = () => {
    if (access_token !== null) {
      openWebSocket(); // reconnect on page reload or after network error
    }
  };
}

export function closeWebSocket() {
  ws?.close(1000);
}

export function sendMessage(msg) {
  const message = JSON.stringify({
    type: "MESSAGE",
    payload: msg,
  });

  if (ws.readyState === WebSocket.OPEN) {
    ws.send(message);
  } else {
    messageQueue.push(message);
  }
}
